<template>
  <div style="height: 45vh">
    <!-- Node Name -->
    <el-row class="row">
      <el-col :span="1"></el-col>
      <el-col :span="4">
        <p class="label">Node name</p>
      </el-col>
      <el-col :span="16">
        <el-radio-group v-model="nodeNameTypeSync" class="radio-row">
          <el-radio value="1" size="small">EXID</el-radio>
          <el-radio value="2" size="small">Preferred name</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <!-- Node Size -->
    <el-row class="row">
      <el-col :span="1"></el-col>
      <el-col :span="4">
        <p class="label">Node size</p>
      </el-col>
      <el-col :span="16">
        <el-slider v-model="nodeSizeSync" max="20"></el-slider>
      </el-col>
    </el-row>

    <!-- Label Size -->
    <el-row class="row">
      <el-col :span="1"></el-col>
      <el-col :span="4">
        <p class="label">Label size</p>
      </el-col>
      <el-col :span="16">
        <el-slider v-model="labelSizeSync" max="20"></el-slider>
      </el-col>
    </el-row>

    <!-- Node Transparency -->
    <el-row class="row">
      <el-col :span="1"></el-col>
      <el-col :span="4">
        <p class="label">Node transparency</p>
      </el-col>
      <el-col :span="16">
        <el-slider v-model="nodeTransparencySync" max="100" step="1"></el-slider>
      </el-col>
    </el-row>

    <!-- Node Color -->
    <el-row class="row">
      <el-col :span="1"></el-col>
      <el-col :span="4">
        <p class="label">Node color</p>
      </el-col>
      <el-col :span="16">
        <el-row>
          <el-col :span="12" style="display: flex; align-items: center;">
            <p style="margin-right: 10px;">Min</p>
            <el-color-picker v-model="deepestColorWithTransparency" show-alpha @change="updateDeepestColor"></el-color-picker>
          </el-col>
          <el-col :span="12" style="display: flex; align-items: center;">
            <p style="margin-right: 10px;">Max</p>
            <el-color-picker v-model="lightestColorWithTransparency" show-alpha @change="updateLightestColor"></el-color-picker>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: "HelloWorld",
  computed: {
    ...mapState(['deepestColor', 'lightestColor', 'nodeTransparency', 'nodeSize', 'volcanoNodeNameType', 'labelSize']),
    nodeSizeSync: {
      get() {
        return this.$store.state.nodeSize;
      },
      set(value) {
        this.SET_NODE_SIZE(value);
        this.$emit('volcano-update', {
          type: 'size',
          size: value
        });
      }
    },
    nodeTransparencySync: {
      get() {
        return this.$store.state.nodeTransparency;
      },
      set(value) {
        this.SET_NODE_TRANSPARENCY(value);
        this.$emit('volcano-update', {
          type: 'transparency',
          transparency: value
        });
      }
    },
    nodeNameTypeSync: {
      get() {
        return this.$store.state.volcanoNodeNameType;
      },
      set(value) {
        this.SET_VOLCANO_NODE_NAME_TYPE(value);
        this.$emit('volcano-update', {
          type: 'nameType',
          nameType: value
        });
      }
    },
    labelSizeSync: {
      get() {
        return this.$store.state.labelSize;
      },
      set(value) {
        this.SET_LABEL_SIZE(value);
        this.$emit('volcano-update', {
          type: 'labelSize',
          size: value
        });
      }
    },
    deepestColorWithTransparency() {
      return this.addTransparencyToColor(this.deepestColor, this.nodeTransparencySync);
    },
    lightestColorWithTransparency() {
      return this.addTransparencyToColor(this.lightestColor, this.nodeTransparencySync);
    }
  },
  data() {
    return {
      frontSize: 10,
    };
  },
  methods: {
    ...mapMutations(['SET_DEEPEST_COLOR', 'SET_LIGHTEST_COLOR', 'SET_NODE_TRANSPARENCY', 'SET_NODE_SIZE', 'SET_VOLCANO_NODE_NAME_TYPE', 'SET_LABEL_SIZE']),
    updateDeepestColor(color) {
      const colorWithTransparency = this.addTransparencyToColor(color, this.nodeTransparencySync);
      this.SET_DEEPEST_COLOR(colorWithTransparency);
      this.$emit('volcano-update', {
        type: 'color',
        deepestColor: colorWithTransparency
      });
    },
    updateLightestColor(color) {
      const colorWithTransparency = this.addTransparencyToColor(color, this.nodeTransparencySync);
      this.SET_LIGHTEST_COLOR(colorWithTransparency);
      this.$emit('volcano-update', {
        type: 'color',
        lightestColor: colorWithTransparency
      });
    },
    addTransparencyToColor(color, transparency) {
      // 如果颜色是 RGB 格式，先转换为 HEX
      if (color.startsWith('rgb')) {
        const rgb = color.match(/\d+/g);
        color = '#' + rgb.map(x => parseInt(x).toString(16).padStart(2, '0')).join('');
      }
      
      // 移除现有的透明度（如果有的话）
      const baseColor = color.slice(0, 7);
      // 将透明度转换为十六进制
      const alpha = Math.round((transparency / 100) * 255).toString(16).padStart(2, '0');
      return `${baseColor}${alpha}`;
    }
  },
};
</script>

<style scoped>
.row {
  font-size: 0.9em;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.label {
  margin: 0;
  line-height: 32px;
  white-space: nowrap; /* 强制不换行 */
}
.radio-row {
  display: flex;
  gap: 10px;
  align-items: center;
}
.color-label {
  line-height: 32px;
  margin-right: 10px;
  float: left;
}
</style>